import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// ✅ Define interface for table rows
interface OrderItem {
  itemName: string;
  manufacturingDate: string;
  expiryDate: string;
  batchNumber: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
}

@Component({
  selector: 'app-clinic-supply',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule
  ],
  templateUrl: './clinicsupply.component.html',
  styleUrl: './clinicsupply.component.scss'
})
export class ClinicSupplyComponent {
  public ClinicSupply = {
    dateOfOrder: '',
    ClinincName: '',
  };

  // ✅ Strongly typed array for product rows
  public orderItems: OrderItem[] = [];

  // ✅ Dropdown item options
  public itemOptions = [
    { label: 'Paracetamol ( 100 ml )', value: 'Paracetamol 100' },
    { label: 'Paracetamol ( 30 ml )', value: 'Paracetamol 30' },
    { label: 'Paracetamol ( 10 ml )', value: 'Paracetamol 10' },
    { label: 'Cough Syrup ( 100 ml )', value: 'Cough Syrup 100' },
    { label: 'Cough Syrup ( 30 ml )', value: 'Cough Syrup 30' },
    { label: 'Cough Syrup ( 10 ml )', value: 'Cough Syrup 10' }
  ];

  // ===== Table Row Functions =====
  addRow() {
    this.orderItems.push({
      itemName: '',
      manufacturingDate: '',
      expiryDate: '',
      batchNumber: '',
      quantity: 0,
      unitPrice: 0,
      totalPrice: 0
    });
  }

  removeRow(index: number) {
    this.orderItems.splice(index, 1);
  }

  calculateRowTotal(index: number) {
    const row = this.orderItems[index];
    const qty = Number(row.quantity) || 0;
    const price = Number(row.unitPrice) || 0;
    row.totalPrice = qty * price;
  }

  calculateFinalPrice(): number {
    return this.orderItems.reduce((sum, row) => sum + (Number(row.totalPrice) || 0), 0);
  }
}
